import type { CoachingHistoryResponse } from '@on3/api';
import clsx from 'clsx';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { Text } from 'components/UI/Typography/Text';
import { useRouter } from 'next/router';

import styles from './CoachHistory.module.scss';

export const CoachHistoryItem = ({
  coachHistoryItems,
}: {
  coachHistoryItems: CoachingHistoryResponse;
}) => {
  const router = useRouter();
  const isFullHistoryPage = router.pathname.includes(
    '/db/coach/[id]/coaching-history',
  );
  const { organization, position, startYear, latestYear, isPresent } =
    coachHistoryItems;
  const { slug, name: orgName } = organization ?? {};
  const { name } = position ?? {};
  const showPresentYear = isPresent ? 'present' : latestYear;

  return (
    <div
      className={clsx(styles.historyItemContainer, {
        [styles.fullPageContainer]: isFullHistoryPage,
      })}
    >
      <TeamAvatar
        className={styles.teamLogo}
        height={30}
        slug={slug ?? 'default'}
        src={organization?.assetUrl}
        width={30}
      />
      <Text className={styles.teamName} variant="h5">
        {orgName}
      </Text>
      <Text className={styles.position} variant="caption">
        {name}
      </Text>
      <Text className={styles.year} variant="caption">
        {startYear} - {showPresentYear}
      </Text>
    </div>
  );
};
